(function () {
  function updateVariantDescription(variantId) {
    const dataEl = document.querySelector('[id^="VariantDescriptions-"]');
    const descEl = document.querySelector('[id^="ProductDescription-"]');
    if (!dataEl || !descEl || !variantId) return;
    try {
      const descriptions = JSON.parse(dataEl.textContent);
      const key = String(variantId);
      let desc = descriptions[key];
      if (desc !== undefined) {
        // Guard: if metafield serialized as object, extract .value
        if (typeof desc === 'object' && desc !== null) desc = desc.value || '';
        descEl.innerHTML = desc;
      }
    } catch (e) {
      console.error('[VariantDesc] Error updating description:', e);
    }
  }

  function updateVariantTitle(variantId) {
    const dataEl = document.querySelector('[id^="VariantTitles-"]');
    const titleEls = document.querySelectorAll('.js-product-title');
    if (!dataEl || !titleEls.length || !variantId) return;
    try {
      const titles = JSON.parse(dataEl.textContent);
      const key = String(variantId);
      let title = titles[key];
      if (title === undefined) return;
      if (typeof title === 'object' && title !== null) title = title.value || '';
      titleEls.forEach((el) => { el.textContent = title; });
    } catch (e) {
      console.error('[VariantTitle] Error updating title:', e);
    }
  }

  function updateVariantSku(variantId) {
    const dataEl = document.querySelector('[id^="VariantSkus-"]');
    const skuEls = document.querySelectorAll('.js-sku');
    if (!dataEl || !skuEls.length || !variantId) return;
    try {
      const skus = JSON.parse(dataEl.textContent);
      const key = String(variantId);
      const sku = skus[key];
      if (sku === undefined || sku === null) return;
      skuEls.forEach((el) => { el.textContent = sku; });
    } catch (e) {
      console.error('[VariantSku] Error updating SKU:', e);
    }
  }

  // Watch for URL changes (same mechanism as badge update)
  document.addEventListener('DOMContentLoaded', function () {
    let lastVariantId = new URLSearchParams(window.location.search).get('variant');

    new MutationObserver(function () {
      const currentVariantId = new URLSearchParams(window.location.search).get('variant');
      if (currentVariantId !== lastVariantId) {
        lastVariantId = currentVariantId;
        if (currentVariantId) {
          updateVariantDescription(currentVariantId);
          updateVariantTitle(currentVariantId);
          updateVariantSku(currentVariantId);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  });
})();

window.addEventListener('load', function(event) {
  // console.log('pdp custom');

  // Select the node that will be observed for mutations
  const targetNode = document.querySelector(".pdp-price-wrap");

  // Options for the observer (which mutations to observe)
  const config = { attributes: false, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        let price = document.querySelector('.pdp-price-wrap .price-item--regular').textContent;
        //console.log(price);
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);

  // Sticky ATC
  let selectOptionsBtn = document.querySelector('.js-atc-scroll');
  if (selectOptionsBtn) {
    selectOptionsBtn.addEventListener('click', function(){
      const element = document.querySelector(".main-pdp-hero");
      const offset = 125;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  }

  let stickyATC = document.querySelector('.js-atc-add');
  if (stickyATC) {
    stickyATC.addEventListener('click', function(){
      document.querySelector('.product-form__submit').click();
    })
  }

  let heroHeight = document.querySelector(".main-pdp-hero").offsetHeight;
  window.onscroll = function() {
    if (window.scrollY > heroHeight) {
      document.querySelector('.sticky-atc').classList.add('sticky-atc--active');
    }else{
      document.querySelector('.sticky-atc').classList.remove('sticky-atc--active');
    }
  };

}, false);